import Vue from 'vue'
import Vuex from 'vuex'

import { playerStatuses } from '@/constants'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    tracksQueue: [],
    tracksQueueCursor: 0,
    playerStatus: playerStatuses.STOPPED
  },
  getters: {
    currentArtist: function (state) {
      if (state.tracksQueue[state.tracksQueueCursor]) {
        return state.tracksQueue[state.tracksQueueCursor].artist
      }
    },
    currentAlbum: function (state) {
      if (state.tracksQueue[state.tracksQueueCursor]) {
        return state.tracksQueue[state.tracksQueueCursor].album
      }
    },
    currentTrack: function (state) {
      return state.tracksQueue[state.tracksQueueCursor]
    },
    currentTrackIndex: function (state) {
      return state.tracksQueueCursor
    },
    currentGenre: function (state) {
      return state.tracksQueue[state.tracksQueueCursor].album.genre
    },
    nextTracks: function (state) {
      return state.tracksQueue.slice(state.tracksQueueCursor + 1)
    },
    isPlaying: function (state) {
      return state.playerStatus === playerStatuses.PLAYING
    },
    isPaused: function (state) {
      return state.playerStatus === playerStatuses.PAUSED
    },
    isStopped: function (state) {
      return state.playerStatus === playerStatuses.STOPPED
    }
  },
  mutations: {
    togglePlay (state) {
      switch (state.playerStatus) {
        case playerStatuses.PLAYING:
          state.playerStatus = playerStatuses.PAUSED
          break
        case playerStatuses.PAUSED:
          state.playerStatus = playerStatuses.PLAYING
      }
    },
    playTrackIndex (state, payload) {
      state.tracksQueueCursor = payload.trackIndex
      state.playerStatus = playerStatuses.PLAYING
    },
    playTracks (state, payload) {
      state.tracksQueue = payload.tracks
      state.tracksQueueCursor = payload.trackIndex || 0
      state.playerStatus = playerStatuses.PLAYING
    },
    nextTrack (state) {
      if (state.tracksQueue[state.tracksQueueCursor + 1]) {
        state.tracksQueueCursor += 1
      } else {
        state.playerStatus = playerStatuses.STOPPED
        state.tracksQueueCursor = 0
        state.tracksQueue = []
      }
    },
    previousTrack (state) {
      if (state.tracksQueueCursor > 0) {
        state.tracksQueueCursor -= 1
      } else {
        state.playerStatus = playerStatuses.STOPPED
        state.tracksQueueCursor = 0
        state.tracksQueue = []
      }
    }
  },
  actions: {
  }
})
